export default __webpack_public_path__ + "static/media/mode-26.f9af7b0f.svg";